import React from "react";
import { ModalV2, Button, Flex, toast } from "@jsq/ds/core";
import { client } from "~/apollo/client";
import { useUpdatePositionCaseMapMutation } from "~/graphql/supergraphHooks";

interface UnlinkCaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  positionId: string;
}

const UnlinkCaseModal: React.FC<UnlinkCaseModalProps> = ({ isOpen, onClose, positionId }) => {
  const [updatePositionMap] = useUpdatePositionCaseMapMutation({
    variables: {
      positionId: positionId,
      caseId: null,
    },
    refetchQueries: ["GetCompliancePositionsList"],
    onError: (e) => {
      toast.error(e.message);
    },
    onCompleted: () => {
      toast.success("Position unlinked successfully");
      void client.refetchQueries({
        include: "active",
      });
      onClose();
    },
  });

  const handleUnlinkPosition = async () => {
    await updatePositionMap();
  };

  return (
    <ModalV2 show={isOpen} onHide={onClose} title="Unlink Case from this position">
      <ModalV2.Body>
        <p>Are you sure you want to unlink this case from the position?</p>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex flexDirection="row" gap={12} justifyContent="flex-end">
          <Button variant="neutral" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleUnlinkPosition}>
            Unlink
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};

export default UnlinkCaseModal;
